import React from "react";
import ReactPaginate from "react-paginate";

const Pagination = ({
                        pageCount,
                        currentPage,
                        onPageChange,
                        itemsPerPage,
                        onItemsPerPageChange,
                        totalItems,
                    }) => {
    const pagingStart = currentPage * itemsPerPage;
    const pagingEnd = Math.min(pagingStart + itemsPerPage, totalItems);

    return (
        <div style={{ marginBottom: 15 }} className="kt-datatable__pager kt-datatable--paging-loaded">
            <ReactPaginate
                previousLabel={<i className="flaticon2-back"></i>}
                nextLabel={<i className="flaticon2-next"></i>}
                breakLabel={"..."}
                pageCount={pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={onPageChange}
                containerClassName="kt-datatable__pager-nav"
                activeClassName="active"
                pageLinkClassName="kt-datatable__pager-link kt-datatable__pager-link-number"
                previousLinkClassName="kt-datatable__pager-link kt-datatable__pager-link--prev"
                nextLinkClassName="kt-datatable__pager-link kt-datatable__pager-link--next"
                activeLinkClassName="kt-datatable__pager-link--active"
                disabledClassName="kt-datatable__pager-link--disabled"
                forcePage={currentPage}
            />
            <div className="kt-datatable__pager-info">
                <div className="kt-datatable__pager-size">
                    <select onChange={onItemsPerPageChange} value={itemsPerPage} className="form-control">
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="30">30</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                </div>
                <span className="kt-datatable__pager-detail">
          Показано {pagingStart + 1} - {pagingEnd} из {totalItems}
        </span>
            </div>
        </div>
    );
};

export default Pagination;
